import { useEffect } from "react";

const useActionMenuTrigger = (handler: () => boolean) => {
  useEffect(() => {
    function detectKey(e: KeyboardEvent) {
      const inputTargets = ["input", "textarea", "[role=textbox]"];
      const target = e.target;
      if (target instanceof Element && inputTargets.some(t => target.matches(t))) return;
      if (!e.shiftKey && e.metaKey && e.key === "k") {
        if (handler()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }

    window.addEventListener("keydown", detectKey);
    return () => {
      window.removeEventListener("keydown", detectKey);
    };
  }, [handler]);
};

export default useActionMenuTrigger;
